module.exports = __webpack_public_path__ + "static/media/france-3-occitanie.e9ba479b.png";